import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { close as closeSign } from 'assets/icons';
import { SvgWrapper } from 'components/atoms/svg-wrapper';
import { errorModalSelector } from 'core/redux/selectors/tep';
import { ModalWrapper } from 'components/molecules/modal-wrapper';
import { actions as leasesActions } from 'core/redux/api/veta/tep/leases';

import styles from './styles.module.css';

export const ErrorModal: FC = () => {
  const dispatch = useDispatch();

  const { isOpen, error } = useSelector(errorModalSelector);

  const close = () => dispatch(leasesActions.clear());

  return isOpen ? (
    <ModalWrapper>
      <div className={styles.content}>
        <span className={styles.close} onClick={close}>
          <SvgWrapper width={26} height={26} details={closeSign} />
        </span>
        <div className={styles.error}>{error}</div>
      </div>
    </ModalWrapper>
  ) : null;
};
